import fetch from "isomorphic-fetch";
import {newNotification} from "./notifications";
import { API2_URL, MODALITIES_REQUEST, MODALITIES_FETCH, MODALITIES_FAIL } from "../store/config";
import _ from "lodash";
import {sessionService} from "redux-react-session";

export const modalitiesList = () => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {
					headers:{
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				dispatch(modalitiesRequest());
				return fetch(`${API2_URL}/modalities?status_id=1`, options)
					.then(result => {
						if(result.status >= 200 && result.status <=300) {
							return result.json();
						} else {
							result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(modalitiesListData(json)),
						error => {
							dispatch(newNotification({title:'¡Oh no!', content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: 'danger'}));
							return dispatch(modalitiesFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
};

const modalitiesRequest = () => {
	return {
		type: MODALITIES_REQUEST,
		isFetching: true,
		timestamp: Date.now()
	}
};

const modalitiesFail = (error) => {
	return {
		type: MODALITIES_FAIL,
		isFetching: false,
		error: error,
		timestamp: Date.now()
	}
};

const modalitiesListData = (json) => {
	return {
		type: MODALITIES_FETCH,
		isFetching: false,
		payload: json.data,
		timestamp: Date.now()
	}
};



// WEBPACK FOOTER //
// ./src/actions/modalities.js